import {Injectable} from '@angular/core';
import {BaseService} from "../../../base/services/base.service";
import {AuthService} from "../../common/modules/auth/services/auth.service";
import {NotifierService} from "../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../base/services/eventbus/event-bus.service";
import {IPage} from "../../../base/models/pagination.model";
import {IVendor} from "../models/inventory/vendor.model";
import {WebAppEndpoint} from "../web-app.endpoint";
import {EventKey} from "../../../registry/event.key";

@Injectable({
  providedIn: 'root'
})
export class VendorService extends BaseService {

  constructor(authService: AuthService,
              notifier: NotifierService,
              private http: HttpClient,
              private eventBus: EventBusService) {
    super(authService, notifier);
  }

  searchVendors(flagship: boolean, query: string): string {
    const key = EventKey.VENDORS.SEARCH_VENDORS()
    this.http.get<IPage<IVendor>>(
      WebAppEndpoint.VENDORS.SEARCH({
        q: query,
        flagship: flagship
      })
    ).subscribe((vendorPage: IPage<IVendor>) => {
      this.eventBus.publish(key, vendorPage)
    }, (error: HttpErrorResponse) => {
      this.eventBus.publish(EventKey.VENDORS.FETCH_ERROR(), error)
    })
    return key
  }
}
